import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import type { PreferredRelationsShipsFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<PreferredRelationsShipsFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <FormField
      control={form.control}
      name="name"
      render={({ field }) => (
        <FormInput
          formItemClassName="col-span-12"
          label="Preferred Relationship (required)"
          {...field}
          disabled={!isEditable}
          autoFocus={autoFocus}
        />
      )}
    />
  );
}
